import { render } from "./GravyModal.vue?vue&type=template&id=97dad71e&scoped=true"
import script from "./GravyModal.vue?vue&type=script&lang=js"
export * from "./GravyModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dad71e"]])

export default __exports__